<script>
  import formatDate from '@utils/format-date'

  export default {
    filters: {
      formatDate,
    },
    props: {
      articleText: {
        type: String,
        default: '',
        // required: true,
      },
      time: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        // articleText,
      }
    },
  }
</script>
<template>
  <div :class="$style.ArticleContent">
    <div class="ArticleContent__content">
      <span v-if="time" class="text-small d-md-block d-none">
        <i class="fal fa-clock"></i> 
        發布時間：{{ time | formatDate('yyyy/MM/dd') }}
      </span>
      <slot/>
      <div class="descirption article" v-html="articleText"></div>
    </div>
  </div>
</template>
<style lang="scss" module>
  .ArticleContent {
    padding-top: 3.75rem;

    @include max-lg {
      padding-bottom: 2.5rem;
      padding-top: 0;
    }

    :global {
      .ArticleContent {
        &__content {
          line-height: 2;

          .text-small {
            display: block;
            margin-bottom: 2.5rem;
          }

          p {
            color: $color-gray-6;
          }

          h2 {
            margin-bottom: 1.5rem;
            font-size: 1.5rem;
          }
          .descirption {
            @include max-md {
              font-size: 1rem;
            }
          }
        }

        &__footer {
          padding-top: 5rem;
        }
      }
    }
  }

  // .pageArrow {
  //   display: flex;
  //   justify-content: space-between;
  //   :global {
  //     .pageArrow {
  //       &__btn {
  //         width: 306px;
  //         max-width: 306px;
  //         &.isPrev {

  //         }
  //         &.isNext {
  //           text-align: right;
  //           .pageArrow {
  //             &__text {
  //               justify-content: flex-end;
  //             }
  //           }
  //         }
  //         &:hover {
  //           text-decoration: none;
  //           .pageArrow {
  //             &__text, &__title {
  //               color: $color-primary;
  //             }
  //           }
  //         }
  //       }
  //       &__text {
  //         display: flex;
  //         align-items: center;
  //         margin-bottom: 1.25rem;
  //         color: $color-gray-7;
  //         transition: color 0.3s
  //       }
  //       &__title {
  //         font-size: 1rem;
  //         line-height: 1.8;
  //         color: $color-gray-5;
  //         transition: color 0.3s
  //       }
  //     }
  //   }
  // }
</style>
